import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { ChevronLeft } from 'lucide-react';

/**
 * صفحة الأسئلة الشائعة بتصميم أكورديون قابل للطي، متسقة مع نمط صفحات السياسات.
 */
const faqData = [
  {
    question: 'كيف يمكنني تتبع طلبي؟',
    answer:
      'يمكنك متابعة حالة طلبك لحظة بلحظة من خلال صفحة "طلباتي" في حسابك على الموقع، بدءًا من التجهيز وحتى وصوله إليك.'
  },
  {
    question: 'هل تتطلب بعض الأدوية روشتة طبية؟',
    answer:
      'نعم، بعض الأدوية تتطلب روشتة طبية سارية، وسيُطلب منك إرفاقها عند إتمام الطلب أو عند استلامه من المندوب.'
  },
  {
    question: 'ما هي طرق الدفع المتاحة؟',
    answer:
      'نوفر الدفع عند الاستلام، بالإضافة إلى الدفع الإلكتروني عبر البطاقات الائتمانية ومحافظ الدفع الإلكترونية. لمزيد من التفاصيل يمكنك زيارة صفحة "طرق الدفع".'
  },
  {
    question: 'ما هي مدة التوصيل المتوقعة؟',
    answer:
      'تتراوح مدة التوصيل داخل المدينة بين ساعة إلى 3 ساعات، بينما قد تصل إلى 24-48 ساعة للمناطق خارج نطاق التوصيل السريع.'
  },
  {
    question: 'هل يمكنني إرجاع منتج بعد استلامه؟',
    answer:
      'نعم، يمكنك طلب الإرجاع خلال 48 ساعة من الاستلام بشرط أن يكون المنتج بحالته الأصلية وغير مستخدم. راجع صفحة "سياسة الإرجاع" لمزيد من التفاصيل.'
  },
  {
    question: 'كيف أتواصل مع خدمة العملاء؟',
    answer:
      'يمكنك التواصل مع فريق خدمة العملاء في أي وقت عبر صفحة "اتصل بنا"، وسنكون سعداء بمساعدتك في أي استفسار.'
  }
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className="border-b border-gray-100 last:border-b-0">
    <button
      onClick={onToggle}
      className="flex w-full items-center justify-between gap-4 py-5 text-right"
    >
      <span className="font-semibold text-gray-900">{item.question}</span>
      <ChevronDown
        className={`h-5 w-5 flex-shrink-0 text-[#10B981] transition-transform duration-200 ${
          isOpen ? 'rotate-180' : ''
        }`}
      />
    </button>
    <div
      className={`grid overflow-hidden transition-all duration-200 ${
        isOpen ? 'grid-rows-[1fr] pb-5' : 'grid-rows-[0fr]'
      }`}
    >
      <div className="overflow-hidden">
        <p className="leading-relaxed text-gray-600">{item.answer}</p>
      </div>
    </div>
  </div>
);

const FAQPage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="min-h-screen bg-gray-50 font-['Cairo']">
      <Header totalItems={totalItems} totalFavorites={totalFavorites} setCurrentPage={setCurrentPage} />

      {/* بانر الصفحة */}
      <div className="border-b bg-white">
        <div className="container mx-auto px-4 py-10">
          <div className="mb-5 flex items-center gap-1.5 text-sm text-gray-500">
            <button
              onClick={() => setCurrentPage('home')}
              className="transition-colors duration-200 hover:text-[#10B981]"
            >
              الرئيسية
            </button>
            <ChevronLeft className="h-3.5 w-3.5" />
            <span className="font-medium text-gray-700">الأسئلة الشائعة</span>
          </div>
          <div className="flex items-center gap-5">
            <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl bg-[#10B981]/10 text-[#10B981]">
              <HelpCircle className="h-8 w-8" />
            </div>
            <div>
              <h1 className="mb-1.5 text-3xl font-bold text-gray-900 lg:text-4xl">
                الأسئلة الشائعة
              </h1>
              <p className="text-sm text-gray-500">إجابات على أكثر الأسئلة تكرارًا من عملائنا</p>
            </div>
          </div>
        </div>
      </div>

      {/* محتوى الصفحة */}
      <div className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-3xl rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-100 lg:p-10">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              item={item}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
      </div>

      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default FAQPage;
